<template>
  <div>
    <van-cell-group style="width: 95%;margin: 0 auto;">
      <van-cell title="统计类型：">
        <template>
          <van-radio-group v-model="queryParams.type" direction="horizontal">
            <van-radio :name="1" clickable>月</van-radio>
            <van-radio :name="2" clickable>日</van-radio>
            <van-radio :name="3" clickable>时间段</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-field v-if="queryParams.type === 1" v-model="queryParams.yearMonth" readonly clickable name="calendar" label="月份" placeholder="点击选择月份" @click="showYearMonth" />
      <van-field v-if="queryParams.type === 2" v-model="queryParams.startDate" readonly clickable name="calendar" label="日期" placeholder="点击选择日期" @click="showCalendar('single')" />
      <van-field v-if="queryParams.type === 3" v-model="time" readonly clickable name="calendar" label="时间段" placeholder="点击选择时间段" @click="showCalendar('range')" />
      <van-field v-model="queryParams.companyName" readonly @click="showPicker('company')" label="公司名称" placeholder="请选择公司名称" />
      <van-field v-model="queryParams.payBankName" readonly @click="queryParams.companyId?showPicker('payBank'):''" label="银行名称" placeholder="请先选择公司名称再选择银行名称" :disabled="!queryParams.companyId" />
    </van-cell-group>
    <div style="display: flex; width: 90%;margin: 10px auto;justify-content: space-around;">
      <van-button type="info" block size="small" icon="search" style="width: 40%;" @click="handleQuery">搜索</van-button>
      <van-button type="warning" block size="small" icon="replay" style="width: 40%;" @click="resetQuery">重置</van-button>
    </div>
    <div class="vant-table">
      <table cellspacing="0" style="width:100%" class="table">
        <tr>
          <th class="th">公司信息</th>
          <th class="th">银行账户名称</th>
          <th class="th">当日余额(元)</th>
        </tr>
        <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
          <td >
            <div class="td_div" v-if="item.companyExpName">{{ item.companyExpName }}</div>
            <div class="td_div" v-else><span>{{ item.companyName }}</span></div>
          </td>
          <td >
            <div class="td_div" v-if="item.payBank">{{ item.payBank }}({{ item.payBankAccountNo.slice(item.payBankAccountNo.length - 4, item.payBankAccountNo.length) }})</div>
            <!-- <div class="td_div" v-if="item.payBankAccountNo"><span>账号：</span>{{ item.payBankAccountNo }}</div> -->
          </td>
          <td>
            <!-- <div class="td_div"><span>期初余额：</span>{{ item.startMoney }}</div>
            <div class="td_div"><span>本期增加：</span>{{ item.inMoney }}</div>
            <div class="td_div"><span>本期减少：</span>{{ item.outMoney }}</div> -->
            <div class="td_div">{{ formaterMoney(item.accountMoney) }}</div>
          </td>
        </tr>
      </table>
    </div>
    <empty-component v-if="tableData.length === 0" />

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="yearMonthPicker.showDate" position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="datePicker.minDate" @confirm="datePickerConfirm" @cancel="yearMonthPicker.showDate = false" />
    </van-popup>
    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" allow-same-day />
  </div>
</template>

<script>
import {
  Grid,
  GridItem,
  DatetimePicker
  // Image as VanImage
  // Cascader
} from 'vant'
import statistics from '@/api/tongji/statistics'
import EmptyComponent from '@/components/common/Empty'
import payment from '@/api/cont/payment'
import { companyList } from '@/api/admi/dept'

export default {
  name: 'TongjiIndex',
  components: {
    EmptyComponent,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [DatetimePicker.name]: DatetimePicker
  },
  props: {},
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      deptList: [],
      payBankList: [],
      currentDate: new Date(),
      yearMonthPicker: {
        showDate: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2023, 0, 1),
        type: 'single',
        formKey: ''
      },
      time: '',
      queryParams: {
        pageNum: 1,
        pageSize: 100,
        total: 0,
        type: 1,
        yearMonth: null,
        startDate: null,
        endDate: null,
        companyId: null,
        payBankId: null
      },
      divisionList: [],
      boSuccessList: [],
      boList: [],
      notBoList: [],
      custList: [],
      businessFunnel: [],
      options: {
        boStageIdOptions: []
      },
      arr: [],
      tableData: [],
      // th
      option: {
        column: []
      },
      timeOptions: [{ dayType: '1', value: '昨天' }, { dayType: '0', value: '今天' }, { dayType: '7', value: '本周' }, { dayType: '30', value: '本月' }, { dayType: '180', value: '上半年' }, { dayType: '365', value: '今年' }]
    }
  },
  async created() {
    this.getList()
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '公司账户余额统计'
    },
    // 获取统计数据
    async getList() {
      if (this.queryParams.type === 1) {
        this.queryParams.startDate = null
        this.queryParams.endDate = null
      } else if (this.queryParams.type === 2) {
        this.queryParams.yearMonth = null
        this.queryParams.endDate = this.queryParams.startDate
      } else if (this.queryParams.type === 3) {
        this.queryParams.yearMonth = null
        if (this.dateRange.length > 0) {
          this.queryParams.startDate = this.dateRange[0]
          this.queryParams.endDate = this.dateRange[1]
        }
      }
      await statistics.listAccountBalances(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.rows
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParams = {
        pageNum: 1,
        pageSize: 100,
        total: 0,
        type: 1,
        yearMonth: null,
        startDate: null,
        endDate: null,
        companyId: null,
        payBankId: null
      }
      this.handleQuery()
    },
    showYearMonth() {
      this.yearMonthPicker.showDate = true
    },
    datePickerConfirm(val) {
      this.queryParams.yearMonth = this.formatDateTime(val)
      this.yearMonthPicker.showDate = false
    },
    formatDateTime(date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      return y + '-' + m
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      // const optionItem = type + 'Options'
      if (type == 'company') {
        // 获取公司信息
        if (this.deptList.length == 0) {
          await companyList({ [this.type == 'channel' ? 'isAll' : null]: 2 }).then((response) => {
            this.deptList = response.rows
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type == 'payBank') {
        // await this.getPayBankList(this.queryParams.companyId)
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      }
      this.picker.loading = false
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      if (this.picker.formKey === 'company') {
        this.queryParams.companyName = this.deptList[key].companyName
        this.queryParams.companyId = this.deptList[key].companyId
        await this.getPayBankList(this.queryParams.companyId)
        this.queryParams.payBankId = ''
        this.queryParams.payBankName = ''
      } else if (this.picker.formKey === 'payBank') {
        this.queryParams.payBankId = this.payBankList[key].incomeBankId
        this.queryParams.payBankName = this.payBankList[key].incomeBankName
      } else {
      // const name = this.picker.formKey+'Name'
        this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.contractStatusName = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    getPayBankList(id) {
      this.payBankList = []
      payment.listPayBank({ companyId: id }).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            const obj = {
              incomeBankId: item.bankAccountId,
              incomeBankName: `${item.bankName}(${item.accountNum})`,
              incomeBankNo: item.accountNum
            }
            this.payBankList.push(obj)
          })
        }
      })
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      this.datePicker.type = type
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      if (this.datePicker.formKey === 'single') {
        this.queryParams.endDate = this.queryParams.startDate = this.formatDate(date)
      } else if (this.datePicker.formKey === 'range') {
        const [start, end] = date
        this.queryParams.startDate = this.formatDate(start)
        this.queryParams.endDate = this.formatDate(end)
        this.time = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
// *{touch-action: none;}
.van-cell {
  touch-action: none;
}

/deep/.van-cell__value{
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0px;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
.Statistics_title{
  margin-top: 15px;
  background-color: #fff;
  padding: 10px 0;
  font-size: 28px;
  color:#87CEFA;
  text-align: center;
}
.vant-table{
  margin-top: 15px;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 120px;
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 24px;
    text-align: center;
    color: #666;
    .th {
      // height: 1.074074rem;
      // line-height: 60px;
      // font-size: 30px;
      // text-align: center;
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr{
      text-align: left;
      .td_div{
        // margin-left: 10px;
        text-align: center;
        span{
          color: #999;
        }
      }
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    // .list-tr:nth-child(2n) {
    //   background-color: #f6f6f6;
    // }
    td {
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}

</style>
